<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36.93 42.41"
  >
    <path
      class="cls-1"
      d="M36.7,30.78c-1.22-3.71-2-5.47-2.58-6.75-.9-2-1.17-2.6-1.84-8.95-.37-3.54-2.47-15.08-13.81-15.08S5.02,11.54,4.65,15.08c-.67,6.35-.94,6.96-1.84,8.95-.58,1.28-1.37,3.03-2.58,6.75-.46,1.4-.22,2.88.64,4.07.86,1.19,2.2,1.87,3.66,1.87h6.64c.73,3.26,3.64,5.7,7.11,5.7h.37c3.47,0,6.38-2.44,7.11-5.7h6.64c1.47,0,2.8-.68,3.66-1.87.86-1.19,1.09-2.67.64-4.07ZM18.65,39.21h-.37c-1.69,0-3.15-1.03-3.77-2.5h7.91c-.62,1.47-2.08,2.5-3.77,2.5ZM33.47,32.97c-.25.35-.64.55-1.07.55H4.53c-.43,0-.82-.2-1.07-.55s-.32-.78-.19-1.19c1.16-3.55,1.91-5.21,2.46-6.43,1.07-2.38,1.41-3.36,2.1-9.93,1.12-10.63,7.14-12.21,10.63-12.21s9.51,1.59,10.63,12.21c.69,6.57,1.03,7.55,2.1,9.93.55,1.21,1.29,2.87,2.46,6.43.13.41.07.84-.19,1.19Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
  vertical-align: -0.125em;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
